import './home.css';
import { CustomCarousel } from '../carousel/carousel';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';

export function Home(){
    const navigate = useNavigate();
    const [checkInDate, setCheckInDate] = useState('');
    const [checkOutDate, setCheckOutDate] = useState('');
    const [guests, setGuests] = useState('1');
    const [roomsCount, setRoomsCount] = useState(1);
    // guestsPerRoom: array of { adults: number, kids: number }
    const [guestsPerRoom, setGuestsPerRoom] = useState([{ adults: 1, kids: 0 }]);
    const [adultTotal, setAdultTotal] = useState(1);
    const [childTotal, setChildTotal] = useState(0);

    useEffect(() => {
        // keep total guests synced with adults+children selects
        setGuests(String(adultTotal + childTotal));
    }, [adultTotal, childTotal]);

    const handleBooking = (e) => {
        e.preventDefault();
        if (checkInDate && checkOutDate) {
            navigate('/book-now');
        }
    };

    // Sample images from gallery
    const heroImages = [
        '/gallery/restaurant/restaurant_5.jpg',
        '/gallery/restaurant/restaurant_3.jpg',
        '/gallery/superior/superior_12.jpg'
    ];

    return (
        <>
            {/* Hero Section with Carousel */}
            <section className="hero-section">
                <CustomCarousel imagesURL={heroImages} />
                <div className="hero-overlay">
                    <div className="hero-content">
                        <h1>Welcome to JANAS Hotel</h1>
                        <p>Experience Premium and Comfort stay</p>
                    </div>
                </div>
            </section>

           {/*  <section className="booking-section">
                <div className="booking-container">
                    <h2>Plan Your Stay</h2>
                    <form onSubmit={handleBooking} className="booking-form">
                        <div className="form-group booking-grid">
                            <div>
                                <label htmlFor="checkIn">Check-in Date</label>
                                <input
                                    type="date"
                                    id="checkIn"
                                    value={checkInDate}
                                    onChange={(e) => setCheckInDate(e.target.value)}
                                    required
                                />
                            </div>
                            <div>
                                <label htmlFor="checkOut">Check-out Date</label>
                                <input
                                    type="date"
                                    id="checkOut"
                                    value={checkOutDate}
                                    onChange={(e) => setCheckOutDate(e.target.value)}
                                    required
                                />
                            </div>
                            <div>
                                <label htmlFor="roomsSelect">Rooms</label>
                                <select id="roomsSelect" value={roomsCount} onChange={(e) => {
                                    const count = parseInt(e.target.value, 10);
                                    setRoomsCount(count);
                                    setGuestsPerRoom(prev => {
                                        const next = prev.slice(0, count);
                                        while (next.length < count) next.push({ adults: 1, kids: 0 });
                                        const total = next.reduce((s, r) => s + r.adults + r.kids, 0);
                                        setGuests(String(total));
                                        return next;
                                    });
                                }}>
                                    <option value={1}>1</option>
                                    <option value={2}>2</option>
                                    <option value={3}>3</option>
                                    <option value={4}>4</option>
                                    <option value={5}>5</option>
                                </select>
                            </div>
                            <div>
                                <label htmlFor="adultsSelect">Adults</label>
                                <select id="adultsSelect" value={adultTotal} onChange={(e) => {
                                    const val = parseInt(e.target.value, 10);
                                    setAdultTotal(val);
                                    setGuests(String(val + childTotal));
                                }}>
                                    {[1,2,3,4,5,6,7,8].map(n => <option key={n} value={n}>{n}</option>)}
                                </select>
                            </div>
                            <div>
                                <label htmlFor="childrenSelect">Children</label>
                                <select id="childrenSelect" value={childTotal} onChange={(e) => {
                                    const val = parseInt(e.target.value, 10);
                                    setChildTotal(val);
                                    setGuests(String(val + adultTotal));
                                }}>
                                    {[0,1,2,3,4,5].map(n => <option key={n} value={n}>{n}</option>)}
                                </select>
                            </div>
                        </div>

                        <div className="center-button" style={{marginTop: 20}}>
                            <button type="submit" className="booking-btn">Check Availability</button>
                        </div>
                    </form>
                </div>
            </section> */}

            {/* Featured Rooms Section */}
            <section className="featured-section">
                <div className="container">
                    <h2>Our Premium Rooms</h2>
                    <p className="section-subtitle">Choose from our carefully curated selection of rooms</p>
                    <div className="rooms-grid">
                        <div className="room-card">
                            <div className="room-image" style={{backgroundImage: `url(${process.env.PUBLIC_URL + '/gallery/deluxe/deluxe_2.jpg'})`}}></div>
                            <div className="room-info">
                                <h3>Deluxe Room</h3>
                                <p>Spacious rooms with modern amenities</p>
                                <div className="room-price">From Rs.2450/night</div>
                                <button className="view-btn" onClick={() => navigate('/rooms')}>View Details</button>
                            </div>
                        </div>
                        <div className="room-card">
                            <div className="room-image" style={{backgroundImage: `url(${process.env.PUBLIC_URL + '/gallery/superior/superior_1.jpg'})`}}></div>
                            <div className="room-info">
                                <h3>Superior Room</h3>
                                <p>Elegant rooms with premium furnishings</p>
                                <div className="room-price">From Rs.2450/night</div>
                                <button className="view-btn" onClick={() => navigate('/rooms')}>View Details</button>
                            </div>
                        </div>
                        <div className="room-card">
                            <div className="room-image" style={{backgroundImage: `url(${process.env.PUBLIC_URL + '/gallery/intcon/intcon_1.jpg'})`}}></div>
                            <div className="room-info">
                                <h3>InterConnected Deluxe</h3>
                                <p>Luxurious interconnected rooms with exclusive services</p>
                                <div className="room-price">From Rs.4550/night</div>
                                <button className="view-btn" onClick={() => navigate('/rooms')}>View Details</button>
                            </div>
                        </div>
                    </div>
                    <div className="center-button">
                        <button className="explore-btn" onClick={() => navigate('/rooms')}>Explore All Rooms</button>
                    </div>
                </div>
            </section>

            {/* Amenities Section */}
            <section className="amenities-section">
                <div className="container">
                    <h2>Why Choose JANAS?</h2>
                    <div className="amenities-grid">
                        <div className="amenity-card">
                            <div className="amenity-icon">🍽️</div>
                            <h3>Fine Dining</h3>
                            <p>Multi‑cuisine restaurant offering best‑in‑class service</p>
                        </div>
                        <div className="amenity-card">
                            <div className="amenity-icon">📶</div>
                            <h3>Free Wi-Fi</h3>
                            <p>High-speed internet throughout the hotel</p>
                        </div>
                        <div className="amenity-card">
                            <div className="amenity-icon">🏆</div>
                            <h3>Booking.com Best Hotel 2024</h3>
                            <p>Recognized for exceptional service and guest satisfaction</p>
                        </div>
                        <div className="amenity-card">
                            <div className="amenity-icon">📍</div>
                            <h3>Location in the Heart of City</h3>
                            <p>Steps away from major attractions, dining, and transport</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Gallery Preview Section */}
            <section className="gallery-section">
                <div className="container">
                    <h2>Gallery Highlights</h2>
                    <p className="section-subtitle">Take a virtual tour of our beautiful hotel</p>
                    <button className="gallery-btn" onClick={() => navigate('/gallery')}>View Full Gallery</button>
                </div>
            </section>

            {/* CTA Section */}
            <section className="cta-section">
                <div className="cta-content">
                    <h2>Ready to Book Your Stay?</h2>
                    <p>Don't miss out on the perfect premium experience</p>
                    <button className="cta-btn" onClick={() => navigate('/book-now')}>Book Now</button>
                </div>
            </section>
        </>
    )
}